import React, { useEffect } from 'react';
import Toast from '@ingka/toast';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../store';
import { selectNotifications } from '../../store/notifications/selectors';
import { removeSnackbar } from '../../store/notifications/actionWrapper';
import skapaColours from '@ingka/variables/colours-css';

const AUTO_HIDE_DURATION = 2500;

const VARIANT_BORDER: Record<string, string> = {
  success: skapaColours.colourSemanticPositive,
  error: skapaColours.colourSemanticNegative,
  warning: skapaColours.colourSemanticCaution,
  info: skapaColours.colourSemanticInformative,
};

const ToastNotifier: React.FC = () => {
  const dispatch = useDispatch();
  const notifications = useTypedSelector(selectNotifications);
  const current = notifications[0] ?? null;

  useEffect(() => {
    if (!current) return;
    const timer = setTimeout(() => {
      dispatch(removeSnackbar(current.key));
    }, AUTO_HIDE_DURATION);
    return () => clearTimeout(timer);
  }, [current?.key, dispatch]);

  const handleClose = () => {
    if (current) {
      dispatch(removeSnackbar(current.key));
    }
  };

  const borderColor = current
    ? (VARIANT_BORDER[current.options.variant] ??
      skapaColours.colourSemanticInformative)
    : undefined;

  return (
    <div
      style={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 9999,
      }}
    >
      <div
        style={
          borderColor
            ? {
                borderLeft: `4px solid ${borderColor}`,
                borderRadius: '4px',
                overflow: 'hidden',
              }
            : undefined
        }
      >
        <Toast
          isOpen={!!current}
          text={current?.msg ?? ''}
          onCloseRequest={handleClose}
          ariaLabelCloseBtn="Dismiss notification"
        />
      </div>
    </div>
  );
};

export default ToastNotifier;
